import { datadogLogs } from '@datadog/browser-logs'
export default defineNuxtPlugin(({ $config }) => {
  datadogLogs.init({
    clientToken: $config.public.datadogClientToken,
    site: $config.public.datadogSite,
    proxy: $config.public.datadogProxy === 'false' ? undefined : options => `${$config.public.datadogProxy}?${options.parameters}`,
    version: $config.public.datadogVersion,
    service: $config.public.datadogService,
    env: $config.public.datadogEnv,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  })
  datadogLogs.setGlobalContextProperty('host', $config.public.datadogHost)
})
